__webpack_require__.p = "https://cdn.jsdelivr.net/npm/ixcanul@0.1.18/dist/";